import React, { Component } from 'react';
import _ from 'lodash';
import { AxlPanel, AxlButton, AxlModal, Colors } from 'axl-reactjs-ui';
// Styles
import styles from './styles';

export default class ShipmentValueInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      arrow: true,
      showPanel: this.props.isOpen
    }
  }

  componentDidMount() {
    if(this.props.arrow !== undefined) {
      this.setState({arrow: this.props.arrow});
    }
  }

  render() {
    const { arrow } = this.state;
    const { shipment } = this.props;
    const shipmentValue = (shipment && shipment.value) ? shipment.value : null
    const shipmentCurrency = (shipment && shipment.currency) ? shipment.currency : null


    return  <AxlPanel style={styles.panelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>Shipment Value:</div>
        <div style={styles.panelHeaderRight}>
          <div style={styles.wrapHeaderEdit}>
          {this.props.openForm &&  
          <div style={styles.panelHeaderButton}><AxlButton tiny bg={`white`} onClick={this.props.openForm && this.props.openForm('ValueInfo')}>{`Edit`}</AxlButton></div>}
          {arrow && <div style={styles.panelHeaderArrow} onClick={() => this.setState({showPanel: !this.state.showPanel})}>
            <i className={!this.state.showPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} />
          </div>}          
          </div>
        </div>
      </div>
      {this.state.showPanel && <AxlPanel.Row style={styles.panelContent}>
        <AxlPanel.Col flex={1}>
          <div style={styles.rowHeaderLabel}>{`Value:`}</div>
          <div>
          {shipmentValue ? `${parseFloat(shipmentValue).toFixed(2)}` : '-'}
          </div>
        </AxlPanel.Col>
        <AxlPanel.Col flex={1}>
          <div style={styles.rowHeaderLabel}>{`Currency:`}</div>
          <div>
            {" "}
            {shipmentCurrency ? shipmentCurrency : '-'}
          </div>
        </AxlPanel.Col>
      </AxlPanel.Row>}
    </AxlPanel>
  }
}
